<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.94498 9.88746C8.99042 9.9329 9.00402 10.0013 8.97942 10.0606C8.95483 10.12 8.89688 10.1587 8.83261 10.1587C8.76834 10.1587 8.7104 10.12 8.6858 10.0606C8.6612 10.0013 8.6748 9.9329 8.72025 9.88746C8.78237 9.82555 8.88286 9.82555 8.94498 9.88746"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.66633 14.1684H3.83057C3.38832 14.1685 2.96415 13.9929 2.65143 13.6802C2.33872 13.3675 2.16309 12.9433 2.16321 12.501V7.49897C2.16309 7.05672 2.33872 6.63255 2.65143 6.31983C2.96415 6.00711 3.38832 5.83148 3.83057 5.8316H9.66633"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.61026 9.88746C5.65571 9.9329 5.6693 10.0013 5.64471 10.0606C5.62011 10.12 5.56217 10.1587 5.49789 10.1587C5.43362 10.1587 5.37568 10.12 5.35108 10.0606C5.32649 10.0013 5.34008 9.9329 5.38553 9.88746C5.44765 9.82555 5.54814 9.82555 5.61026 9.88746"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="12.1674"
      y="8.74948"
      width="6.66944"
      height="5.41892"
      rx="1.65"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.4424 8.74949V7.05761C13.4424 5.92008 14.3645 4.99792 15.5021 4.99792V4.99792C16.0483 4.99792 16.5722 5.21493 16.9585 5.60119C17.3447 5.98746 17.5617 6.51135 17.5617 7.05761V7.05761V8.76359"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
